import {
  keepPreviousData,
  queryOptions,
  useQuery,
  useSuspenseQuery,
} from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import {
  listarOrganizacionesAdmin,
  listarTodasLasOrganizaciones,
  type ListarOrganizacionesParams,
} from "../services/organizaciones-service";

/**
 * Catálogo COMPLETO de organizaciones (sin paginar) · lo consume el admin
 * de usuarios (panel de edición + filtro). Comparte el prefijo
 * `qk.adminOrganizaciones` con el listado paginado, así una mutación
 * invalida ambas variantes de un tiro.
 */
export const organizacionesAdminQueryOptions = queryOptions({
  queryKey: [...qk.adminOrganizaciones, "todas"] as const,
  queryFn: listarTodasLasOrganizaciones,
});

export const useOrganizacionesAdmin = () =>
  useSuspenseQuery(organizacionesAdminQueryOptions);

/**
 * Listado PAGINADO (server-side) para la página /admin/organizaciones ·
 * búsqueda + página en el queryKey · `keepPreviousData` evita parpadeo.
 */
export const organizacionesAdminPageQueryOptions = (
  params: ListarOrganizacionesParams = {}
) =>
  queryOptions({
    queryKey: [...qk.adminOrganizaciones, params] as const,
    queryFn: () => listarOrganizacionesAdmin(params),
    placeholderData: keepPreviousData,
  });

export const useOrganizacionesAdminPage = (params: ListarOrganizacionesParams = {}) =>
  useQuery(organizacionesAdminPageQueryOptions(params));
